<div class="chat-share-popup">
    <div class="popup-header">
        <div>Share</div>
        <mat-icon class="close-icon" (click)="close()">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div class="popup-content">
        <div class="content-title">{{title}}</div>
        <button mat-stroked-button color="primary" class="copy" (click)="copyShareLink()">
             <mat-icon class="link-icon">link</mat-icon>Copy link
        </button>
    </div>
</div>